import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAcceptCall = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.06612 2.59779L8.34612 5.6698C8.57012 6.1818 8.44212 6.7898 7.99412 7.1418L6.42612 8.4538C7.48212 10.6938 9.30613 12.5178 11.5461 13.5738L12.8581 12.0058C13.2101 11.5578 13.8181 11.4298 14.3301 11.6538L17.4021 12.9338C18.0101 13.1578 18.2981 13.8298 18.1381 14.4378L17.3701 17.2538C17.2101 17.7978 16.7301 18.1818 16.1541 18.1818C8.21812 18.1818 1.81812 11.7818 1.81812 3.84579C1.81812 3.26979 2.20212 2.78979 2.74612 2.62979L5.56212 1.86179C6.17012 1.70179 6.84212 1.98979 7.06612 2.59779Z",
		fill: "currentColor"
	})
});
export default SvgAcceptCall;
